export default {"src":"https://cloudflare.edhrec.com/_next/static/media/manarw.02e6a537.svg","height":600,"width":600,"blurWidth":0,"blurHeight":0};